/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_List_NowInputs */

const en_us2_workout_list_now = /** @type {(inputs: Workout_List_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Now`)
};

const pt_br2_workout_list_now = /** @type {(inputs: Workout_List_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agora`)
};

const es_419_workout_list_now = /** @type {(inputs: Workout_List_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahora`)
};

const pt_pt2_workout_list_now = /** @type {(inputs: Workout_List_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agora`)
};

const fr_fr2_workout_list_now = /** @type {(inputs: Workout_List_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours`)
};

const de_de2_workout_list_now = /** @type {(inputs: Workout_List_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt`)
};

const it_it2_workout_list_now = /** @type {(inputs: Workout_List_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ora`)
};

/**
* | output |
* | --- |
* | "Now" |
*
* @param {Workout_List_NowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_list_now = /** @type {((inputs?: Workout_List_NowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_List_NowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_list_now(inputs)
	if (locale === "es-419") return es_419_workout_list_now(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_list_now(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_list_now(inputs)
	if (locale === "de-DE") return de_de2_workout_list_now(inputs)
	if (locale === "it-IT") return it_it2_workout_list_now(inputs)
	return en_us2_workout_list_now(inputs)
});
export { workout_list_now as "workout.list_now" }